import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OEAnatomyTargetType, OEAnatomyTargets, OEAnatomyFeatureAccess, OEAnatomyStartSelectionData} from './oe-anatomy-model';

export default class OEAnatomyCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OEAnatomyTargetType.head]:     {icon: OEIconCodes.anatomy.headTarget, titleId: 'target_menu_head'},
            [OEAnatomyTargetType.anatomy]:  {icon: OEIconCodes.anatomy.anatomyTarget, titleId: 'target_menu_anatomy'},
            [OEAnatomyTargetType.organs]:   {icon: OEIconCodes.anatomy.organsTarget, titleId: 'target_menu_organs'},
            [OEAnatomyTargetType.biology]:  {icon: OEIconCodes.anatomy.biologyTarget, titleId: 'target_menu_biology'},
            [OETarget.effigosExplorerHelp]: {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = [OEAnatomyTargetType.head, OEAnatomyTargetType.anatomy, OEAnatomyTargetType.organs, OEAnatomyTargetType.biology, OETarget.effigosExplorerHelp];

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OEAnatomyTargets}
                featureAccess={OEAnatomyFeatureAccess}
                startSelectionData={OEAnatomyStartSelectionData}
            />
        );
    }
}